

































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { MobileGetter } from 'frontend/types';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';
import BriocheBackgroundImage from 'frontend/components/BriocheBackgroundImage.vue';

@Component({
  components: {
    BriocheBackgroundImage,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class CardBackground extends Vue {
  @Prop({ type: Object, required: true })
  private learningPath!: RelatedLearningPathInfo;

  private readonly isMobile!: MobileGetter;
}
